// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconSuitCase = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
    className,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 18,
    width: 20,
  }

  const iconSvgClassName = `c-icon-suitcase__svg fill-current ${className}`;

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-suitcase">
      <svg
        className={iconSvgClassName}
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17.6251 3.17289H14.0261V2.21075C14.0261 0.991723 13.0392 0 11.8265 0H8.17417C6.96006 0 5.9725 0.991723 5.9725 2.21075V3.17289H2.37452C1.06516 3.17289 0 4.24293 0 5.55838V15.6138C0 16.9296 1.06516 18 2.37452 18H17.6251C18.9345 18 20 16.9296 20 15.6138V5.55838C20.0003 4.24293 18.9348 3.17289 17.6251 3.17289ZM7.55551 2.21075C7.55551 1.86892 7.83297 1.59079 8.17417 1.59079H11.8269C12.1667 1.59079 12.4431 1.86892 12.4431 2.21075V3.17289H7.55551V2.21075ZM2.37452 4.76368H17.6251C18.0619 4.76368 18.417 5.12013 18.417 5.55838V8.51789H11.2397H8.76095H1.58301V5.55838C1.58301 5.12013 1.93806 4.76368 2.37452 4.76368ZM9.08068 10.109H10.9197V11.8366H9.08068V10.109ZM17.6251 16.4092H2.37452C1.93806 16.4092 1.58301 16.0524 1.58301 15.6138V10.109H7.49766V12.1586C7.49766 12.8583 8.06436 13.4278 8.76095 13.4278H11.2397C11.9363 13.4278 12.5027 12.8583 12.5027 12.1586V10.109H18.417V15.6138C18.4173 16.0524 18.0619 16.4092 17.6251 16.4092Z" fill={fill || ''} />
      </svg>
    </Icon>
  );
};

export default IconSuitCase;
